'use client';

type LogoutUrlResponse = {
  url?: unknown;
};

export type BrowserLogoutOptions = {
  cancelRedirectUrl?: string;
  skipConfirmation?: boolean;
};

export const SPORTSFI_LOGOUT_CANCEL_REDIRECT_PARAM = 'sportsfi_cancel_redirect_uri';
export const SPORTSFI_LOGOUT_SKIP_CONFIRMATION_PARAM = 'skipConfirmation';

export function withBrowserLogoutCancelRedirect(logoutUrl: string, cancelRedirectUrl: string): string {
  if (typeof window === 'undefined') {
    return logoutUrl;
  }

  const parsedLogoutUrl = new URL(logoutUrl, window.location.origin);
  const parsedCancelRedirectUrl = new URL(cancelRedirectUrl, window.location.origin);

  parsedLogoutUrl.searchParams.set(SPORTSFI_LOGOUT_CANCEL_REDIRECT_PARAM, parsedCancelRedirectUrl.toString());

  return parsedLogoutUrl.toString();
}

export async function getBrowserLogoutUrl(callbackUrl: string, options?: BrowserLogoutOptions): Promise<string | null> {
  if (typeof window === 'undefined') {
    return null;
  }

  const logoutUrlEndpoint = new URL('/api/session/logout-url', window.location.origin);

  logoutUrlEndpoint.searchParams.set('callbackUrl', callbackUrl);

  if (options?.skipConfirmation === true) {
    logoutUrlEndpoint.searchParams.set(SPORTSFI_LOGOUT_SKIP_CONFIRMATION_PARAM, 'true');
  }

  const response = await fetch(logoutUrlEndpoint.toString(), {
    credentials: 'same-origin',
    headers: {
      Accept: 'application/json',
    },
  });

  if (!response.ok) {
    return null;
  }

  const body = (await response.json()) as LogoutUrlResponse;

  if (typeof body.url !== 'string' || body.url.length === 0) {
    return null;
  }

  const browserLogoutUrl = new URL(body.url, window.location.origin).toString();

  if (options?.skipConfirmation === true) {
    return browserLogoutUrl;
  }

  return withBrowserLogoutCancelRedirect(browserLogoutUrl, options?.cancelRedirectUrl ?? window.location.href);
}
